import { useEffect } from 'react';

function VLibras() {
  useEffect(() => {
    if (document.querySelector('[vw]')) return;

    const wrapper = document.createElement('div');
    wrapper.setAttribute('vw', '');
    wrapper.className = 'enabled';

    const accessButton = document.createElement('div');
    accessButton.setAttribute('vw-access-button', '');
    accessButton.className = 'active';

    const pluginWrapper = document.createElement('div');
    pluginWrapper.setAttribute('vw-plugin-wrapper', '');
    const topWrapper = document.createElement('div');
    topWrapper.className = 'vw-plugin-top-wrapper';
    pluginWrapper.appendChild(topWrapper);

    wrapper.appendChild(accessButton);
    wrapper.appendChild(pluginWrapper);
    document.body.appendChild(wrapper);

    const script = document.createElement('script');
    script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
    script.async = true;
    script.onload = () => {
      if (window.VLibras) {
        new window.VLibras.Widget('https://vlibras.gov.br/app');
      }
    };
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(wrapper)) document.body.removeChild(wrapper);
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, []);

  return null;
}

export default VLibras;
